window.klaviyo = window.klaviyo || []

window.klaviyo.init({
  account: 'NRuTRu',
  platform: 'shopify',
})

window.klaviyo.enable('backinstock', {
  variant_id_element: '#klaviyo-bis-variant-id',
  variant_id_attribute: 'value',
  collection_urls: ['^.+://[^/]+/?(\\?.*)?$'],
  trigger: {
    product_page_text: 'Notify me',
    product_page_class: 'primary',
    product_page_text_align: 'center',
    product_page_margin: '20px',
    replace_anchor: false,
  },
  modal: {
    headline: '{product_name}',
    body_content: 'Register to receive a notification when this item comes back in stock.',
    email_field_label: 'Email',
    button_label: 'Notify me when available',
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: '',
    additional_styles: '',
    drop_background_color: '#000',
    background_color: '#fff',
    text_color: '#39000b',
    button_text_color: '#39000b',
    button_background_color: '#ff87d3',
    close_button_color: '#39000b',
    error_background_color: '#fcd6d7',
    error_text_color: '#C72E2F',
    success_background_color: '#ff87d3',
    success_text_color: '#39000b',
  },
})
